import { bindable, computedFrom } from 'aurelia-framework';

class ProductFeedsJobViewer {
  @bindable loading = false;
  @bindable account = null;
  @bindable job = null;
  @bindable log = '';
  @bindable route = '';
  @bindable done = false;
  @bindable running = false;
  @bindable cancelled = false;
  @bindable onCancelJob = () => {};
  logChanged() {
    if (this.running && this.logView) {
      setTimeout(() => {
        this.logView.scrollTop = this.logView.scrollHeight;
      }, 0);
    }
  }
  @computedFrom('running', 'done', 'cancelled')
  get isTheJobStillRunning() {
    return this.running && !this.done && !this.cancelled;
  }
}

export { ProductFeedsJobViewer };
